import React from 'react';

const MIN_TO_DISPLAY = 5;
export default class RuleTags extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setShowAll = this.setShowAll.bind(this);

    this.state = {showAll: false};
  }
  setShowAll(value) {
    this.setState({showAll: value});
  }
  render() {
    const showAll = this.state.showAll;
    const tagNames = this.props.tagNames;
    const display = showAll ? tagNames : tagNames.take(MIN_TO_DISPLAY);
    const hasMore = tagNames.size > MIN_TO_DISPLAY;

    // TODO: <a> must be replaced with <button> and eslint ignore must be removed
    /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
    return (
      <div>
        {display.map(tag => (
          <span className="tag-name" key={tag}>
            {'#' + tag}
          </span>
        ))}
        {!showAll && hasMore && (
          <a className="toggle-more" onClick={() => this.setShowAll(true)}>
            +{tagNames.size - MIN_TO_DISPLAY}&nbsp;more
          </a>
        )}
        {showAll && hasMore && (
          <a className="toggle-more" onClick={() => this.setShowAll(false)}>
            show&nbsp;less
          </a>
        )}
      </div>
    );
  }
}
